import { IconButton } from '@mui/material'
import FullscreenIcon from '@mui/icons-material/Fullscreen'
import BaseWidgetProvider from './base/BaseWidgetProvider'

const WidgetFullScreenToogle = () => {
  return (
    <IconButton
      sx={{
        width: '100%',
        height: '100%',
        borderRadius: 1, // rectangle
        '& .MuiTouchRipple-root': {
          borderRadius: 0
        }
      }}
      disableRipple
    ><FullscreenIcon />
    </IconButton>
  )
}

class WidgetFullScreenToogleProvider extends BaseWidgetProvider {
  getCode = () => 'WidgetFullScreenToogleProvider'

  getName = () => 'Fullscreen'

  getIcon = () => FullscreenIcon

  createWidget = (props) => <WidgetFullScreenToogle {...props} />

  onClick = (props) => {
    if (document.fullscreenElement) {
      document.exitFullscreen()
    } else {
      props.enableFullscreen()
    }
  }

  isClickable = () => true

  getWidgetInfo = (columns, cellHeight) => {
    return { ...super.getWidgetInfo(columns, cellHeight), availableWithoutDevice: true, hideHeader: true }
  }
}

export default WidgetFullScreenToogleProvider
